(function setupTooltipToggle() {
	const isTouchDevice = !window.matchMedia('(hover: hover)').matches;

	const bound = new WeakSet();

	function bindTooltip(el) {
		if (!el || !el.classList.contains('tooltip') || bound.has(el)) return;

		el.addEventListener('click', (e) => {
			e.stopPropagation();
			// close all the tooltips before open
			document.querySelectorAll('.tooltip.is-open').forEach((t) => {
				if (t !== el) t.classList.remove('is-open');
			});
			el.classList.toggle('is-open');
		});

		bound.add(el);
	}

	function bindAll(root = document) {
		if (!isTouchDevice) return;
		root.querySelectorAll('.tooltip').forEach(bindTooltip);
	}

	bindAll();

	// close all the tooltips
	document.addEventListener('click', () => {
		document.querySelectorAll('.tooltip.is-open').forEach((t) => t.classList.remove('is-open'));
	});

	// observe the html changes
	const observer = new MutationObserver((mutations) => {
		if (!isTouchDevice) return;
		for (const m of mutations) {
			m.addedNodes.forEach((node) => {
				if (node.nodeType !== 1) return; // only elements
				if (node.classList && node.classList.contains('tooltip')) bindTooltip(node);
				if (node.querySelectorAll) node.querySelectorAll('.tooltip').forEach(bindTooltip);
			});
		}
	});

	observer.observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
})();
